import { NgModule } from "@angular/core";
import { Routes,RouterModule } from "@angular/router";
import { FmsAgencyComponent } from "./fms-agency.component";

const routes: Routes = [{path:'',component:FmsAgencyComponent}];


@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule]
})
export class FmsAgencyRoutingModule { }